module.exports = __webpack_public_path__ + "img/00_logo_h.f0ba80a8.svg";